import type ErrorData from 'sharedreact/data/ErrorData';
import type Version from 'sharedreact/data/Version';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

type OnFetchSuccess = (version: Version) => void;
type OnFetchError = (error: ErrorData) => void;

type OnGetLegalNoticesSuccess = (legalNotices: string) => void;

function fetch (onSuccess: OnFetchSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'getVersionInfo',
    {},
    (data) => onSuccess(data.version),
    onError
  );
}

function getLegalNotices (onSuccess: OnGetLegalNoticesSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'getLegalNotices',
    {},
    (data) => onSuccess(data),
    onError
  );
}

export default {
  fetch,
  getLegalNotices
};
